import { startFunnelSession, recordFunnelStep, endFunnelSession, getFunnelSessionState } from "@/utils/behaviorTracker";
import { safeTrack } from "./track";
import { PAGE_KEYS } from "./pageKeys";

const REGISTER_PAGE_KEY = PAGE_KEYS.REGISTER_MAIN;
const LOGIN_PAGE_KEY = PAGE_KEYS.LOGIN_MAIN;

export function trackRegisterPageView({ pagePath, registerChannel }) {
  startFunnelSession("register", { registerChannel });
  recordFunnelStep(2);
  return safeTrack("register_page_view", {
    page: pagePath || "",
    properties: {
      page_key: REGISTER_PAGE_KEY,
      ...(registerChannel ? { register_channel: registerChannel } : {}),
    },
  });
}

export function trackRegisterCountryConfirm({ countryId, pagePath }) {
  recordFunnelStep(3);
  return safeTrack("register_country_confirm", {
    page: pagePath || "",
    properties: {
      page_key: REGISTER_PAGE_KEY,
      country_id: Number(countryId),
    },
  });
}

export function trackRegisterFormSubmit({ pagePath }) {
  recordFunnelStep(4);
  return safeTrack("register_form_submit", {
    page: pagePath || "",
    properties: { page_key: REGISTER_PAGE_KEY },
  });
}

export function trackRegisterFail({ errorCode, failStep, pagePath }) {
  return safeTrack("register_fail", {
    page: pagePath || "",
    properties: {
      page_key: REGISTER_PAGE_KEY,
      error_code: String(errorCode || "UNKNOWN"),
      ...(failStep != null ? { fail_step: Number(failStep) } : {}),
    },
  });
}

export function trackRegisterAbandon({ lastStep, pagePath }) {
  const state = getFunnelSessionState();
  safeTrack("register_abandon", {
    page: pagePath || "",
    properties: {
      page_key: REGISTER_PAGE_KEY,
      last_step: Number(lastStep != null ? lastStep : state?.lastStep || 1),
    },
  });
  endFunnelSession();
}

export function trackRegisterEntryClick({ entry, pagePath, pageKey = PAGE_KEYS.HOME }) {
  startFunnelSession("register");
  recordFunnelStep(1);
  return safeTrack("register_entry_click", {
    page: pagePath || "",
    properties: { entry, page_key: pageKey },
  });
}

export function trackLoginFail({ errorCode, pagePath, loginMethod }) {
  return safeTrack("login_fail", {
    page: pagePath || "",
    properties: {
      page_key: LOGIN_PAGE_KEY,
      error_code: String(errorCode || "UNKNOWN"),
      ...(loginMethod ? { login_method: loginMethod } : {}),
    },
  });
}

export function resolveRegisterChannelFromQuery(query = {}) {
  if (query.ref || query.invite) return "invite";
  if (query.deeplink) return "deeplink";
  if (query.from === "banner") return "banner";
  return "home";
}
